export type SizePresetKey = "small" | "large"
export const defaultSizePreset: SizePresetKey = "large"
